import { useSelector } from 'react-redux';
import findResult from '@/utils/resultsHelper';
import { readStates } from '@/constants/lifecycle';

// Tying allowRefresh to update permission as only those who can change dictionarys really need
// the ability to refresh, users who can't will generally find the option superfluous
const useDictionaryMarkdownActions = ({ category, code }) => useSelector(({
  auth: { role: { permissions } },
  dictionaryMarkdown: { markdowns },
}) => {
  const item = findResult(markdowns, category, code) || { text: '', ...readStates, datasetCode: null };
  return {
    allowDownload: permissions.datasets.download,
    allowRead: permissions.datasets.read,
    allowRefresh: permissions.datasets.update,
    datasetCode: item.datasetCode,
    readStatus: item.readStatus,
    text: item.text,
  };
});

const useDictionaryMarkdownPanelAll = ({ category, code }) => useSelector(({
  auth: { role: { permissions } },
  dictionaryMarkdown: { markdowns },
}) => {
  const item = findResult(markdowns, category, code) || { text: '', name: '', ...readStates };
  return {
    canRead: permissions.datasets.download,
    name: item.name,
    readErrors: item.readErrors,
    readStatus: item.readStatus,
    text: item.text,
  };
});

export default {
  useDictionaryMarkdownActions,
  useDictionaryMarkdownPanelAll,
};
